// src/components/MainPage.js
import React from 'react';
import styles from './FearAndGreed.module.css';
import FearAndGreedDashboard from '../components/FearAndGreedDashboard';


function FearAndGreed(){    

    return (
        <div className={styles.main_page}>
            <header className={styles.main_header}>
                <h1>Fear & Greed Index</h1>
            </header>
            <main>
                <FearAndGreedDashboard showDetails={true} />                
            </main>           
        </div>
    );
}

export default FearAndGreed;






